import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import styled from '@emotion/styled';

import CheveronRight from '../Icons/CheveronRight';
import { InternalLink } from '../Link/Link';

interface Ipath {
  name: string;
  link: string;
}

interface IBreadCrumbs {
  pathData: Ipath[];
}

const BreadCrumbs: React.FC<IBreadCrumbs> = ({ pathData }) => {
  const { pathname } = useLocation();
  const { id } = useParams();

  return (
    <Container>
      {pathData.map((item, index) => {
        return (
          <React.Fragment key={index}>
            {index / 2 !== 0 && <CheveronRight />}
            <>
              {`${item.link}/${id}` === pathname ? (
                <LinkShell
                  className={`${item.link}/${id}` === pathname ? 'active' : ''}
                >
                  {item.name}
                </LinkShell>
              ) : (
                <InternalLink to={item.link}>
                  <LinkShell
                    className={
                      `${item.link}/${id}` === pathname ? 'active' : ''
                    }
                  >
                    {item.name}
                  </LinkShell>
                </InternalLink>
              )}
            </>
            {/* <InternalLink to={item.link}>
              <LinkShell
                className={`${item.link}/${id}` === pathname ? 'active' : ''}
              >
                {item.name}
              </LinkShell>
            </InternalLink> */}
          </React.Fragment>
        );
      })}
    </Container>
  );
};

export default BreadCrumbs;

const Container = styled.div`
  display: flex;
  /* justify-content: center; */
  align-items: center;
  gap: 0.5rem;
  /* border: 2px solid red; */
`;

const LinkShell = styled.div`
  display: flex;
  background-color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  color: #c2bebc;

  &.active {
    color: #867c79;
    font-weight: 700;
    cursor: default;
  }
`;
